import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import getItemFromLocalStorage from 'utils/getItemFromLocalStorage';

const PrivateRoute = ({ component: Component, path }: any) => {
  // Simple client-side validation - no loading state, no API calls
  const user = getItemFromLocalStorage('user');

  // If no valid user or token, redirect to login
  if (!user || !user.access) {
    return <Redirect exact to={{ pathname: '/login', state: { from: window.location.pathname } }} />;
  }

  // path may be a string or string[] (e.g. settings layout routes)
  const paths: string[] = Array.isArray(path) ? path : [path];
  const isDynamicRoute = paths.some((p) => typeof p === 'string' && p.includes(':'));

  return <Route exact={!isDynamicRoute} path={path} component={Component} />;
};

export default PrivateRoute;
